// Telugu — shared key set with the Flutter apps (lib/l10n).
// Auto-generated from the Dart source of truth; keep both in sync.
// Flat, dotted keys — i18n is configured with keySeparator:false.

const te: Record<string, string> = {
  "common.save": "సేవ్ చేయి",
  "common.cancel": "రద్దు చేయి",
  "common.delete": "తొలగించు",
  "common.edit": "సవరించు",
  "common.add": "జోడించు",
  "common.close": "మూసివేయి",
  "common.back": "వెనుకకు",
  "common.done": "పూర్తయింది",
  "common.yes": "అవును",
  "common.no": "కాదు",
  "common.confirm": "నిర్ధారించు",
  "common.search": "వెతుకు",
  "common.retry": "మళ్ళీ ప్రయత్నించు",
  "common.loading": "లోడ్ అవుతోంది…",
  "common.offline": "ఆఫ్‌లైన్",
  "nav.settings": "సెట్టింగ్‌లు",
  "nav.orders": "ఆర్డర్‌లు",
  "nav.tables": "టేబుళ్లు",
  "nav.menu": "మెనూ",
  "nav.reports": "నివేదికలు",
  "roles.pos": "పాయింట్ ఆఫ్ సేల్",
  "roles.kds": "కిచెన్ డిస్‌ప్లే",
  "roles.customer": "కస్టమర్ డిస్‌ప్లే",
  "roles.captain": "కెప్టెన్",
  "roles.kiosk": "సెల్ఫ్-ఆర్డర్ కియోస్క్",
  "order.dineIn": "డైన్-ఇన్",
  "order.takeaway": "టేక్‌అవే",
  "order.delivery": "డెలివరీ",
  "order.quickBill": "క్విక్ బిల్",
  "order.newOrder": "కొత్త ఆర్డర్",
  "order.sendToKitchen": "కిచెన్‌కు పంపు",
  "order.addItem": "ఐటమ్ జోడించు",
  "order.cart": "కార్ట్",
  "order.empty": "ఇంకా ఐటమ్‌లు లేవు",
  "bill.settle": "బిల్లు సెటిల్ చేయి",
  "bill.subtotal": "ఉప-మొత్తం",
  "bill.discount": "తగ్గింపు",
  "bill.total": "మొత్తం",
  "bill.gst": "జీఎస్టీ",
  "bill.customerName": "కస్టమర్ పేరు",
  "bill.token": "టోకెన్",
  "bill.billNo": "బిల్లు నంబర్",
  "bill.splitBill": "బిల్లు విభజించు",
  "bill.splitBySeat": "సీటు వారీగా విభజించు",
  "bill.pay": "చెల్లించు",
  "bill.print": "ప్రింట్ చేయి",
  "bill.paid": "చెల్లించబడింది",
  "bill.pending": "పెండింగ్‌లో",
  "table.free": "ఖాళీ",
  "table.occupied": "నిండింది",
  "table.transfer": "బదిలీ చేయి",
  "table.merge": "విలీనం చేయి",
  "settings.language": "భాష",
  "settings.tax": "పన్ను",
  "settings.printing": "ప్రింటింగ్",
  "settings.account": "ఖాతా & ప్లాన్",
  "settings.general": "సాధారణ",
  "settings.deviceMode": "పరికర మోడ్",
  "settings.chooseLanguage": "భాషను ఎంచుకోండి",
  "nav.order": "ఆర్డర్",
  "nav.online": "ఆన్‌లైన్",
  "nav.activity": "కార్యకలాపం",
  "nav.history": "చరిత్ర",
  "nav.import": "దిగుమతి",
  "nav.endShift": "షిఫ్ట్ ముగించు",
  "settings.title": "సెట్టింగ్‌లు",
  "settings.subtitle": "అవుట్‌లెట్, పన్ను, ప్రింటర్లు, పాత్రలు & బిల్లు ఫార్మాట్",
  "settings.sectionOutlet": "అవుట్‌లెట్ & బ్రాండింగ్",
  "settings.sectionTax": "పన్ను & జీఎస్టీ",
  "settings.sectionPrinters": "ప్రింటర్లు & కేఓటీ",
  "settings.sectionRoles": "పాత్రలు & అనుమతులు",
  "settings.sectionBillFormat": "బిల్లు ఫార్మాట్",
  "settings.sectionChannels": "ఆన్‌లైన్ ఛానెల్‌లు",
  "settings.sectionAccount": "ఖాతా & ప్లాన్‌లు",
  "settings.sectionAbout": "గురించి & నవీకరణలు",
  "order.viewCart": "కార్ట్ చూడండి",
  "order.categories": "వర్గాలు",
  "order.tapToBuild": "ఆర్డర్ రూపొందించడానికి వంటకాలను నొక్కండి",
  "order.addNote": "గమనిక జోడించు",
  "order.searchDishes": "వంటకాలను వెతుకు",
  "bill.settleAndPrint": "సెటిల్ చేసి ప్రింట్ చేయి",
  "menu.title": "మెనూ & ఐటమ్‌లు",
  "menu.searchItems": "ఐటమ్‌లను వెతుకు…",
  "menu.noItems": "ఇక్కడ ఐటమ్‌లు లేవు",
  "menu.addItemBtn": "ఐటమ్ జోడించు",
  "menu.tapAddItem": "రూపొందించడానికి “ఐటమ్ జోడించు” నొక్కండి",
  "menu.addCategory": "వర్గం జోడించు",
  "menu.newCategory": "కొత్త వర్గం",
  "order.allFired": "అన్నీ పంపబడ్డాయి",
  "bill.settling": "సెటిల్ అవుతోంది…"
};

export default te;
